import { ArrowUp } from 'lucide-react';
import { profile } from '@/data';

export function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-4 px-6 py-8">
        <p className="text-sm text-muted-foreground">
          {profile.name} · {profile.title}
        </p>
        <a
          href="#top"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowUp className="h-4 w-4" aria-hidden />
          Back to top
        </a>
      </div>
    </footer>
  );
}
